import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {withRouter, Link} from 'react-router-dom'

import {link as clientWebLink} from '../../../lib/clientweb'
import styles from './Style.css'
import className from 'classnames'

const items = {
	"Home": {icon: 'sprite-homepage-Sidebar-Home2x', link: clientWebLink('/')},
	"Budget" : {icon: 'sprite-homepage-Sidebar-Budget2x', items: [
		[clientWebLink('/budget'), '12 Months'],
		[clientWebLink('/budget/future'), 'Future Payment Report'],
		[clientWebLink('/withdrawal/withdraw'), 'Access/Transfer Money'],
		[clientWebLink('/budget/incomes'), 'Verify Incomes'],
		[clientWebLink('/budget/depositslip'), 'Deposit'],
		[clientWebLink('/balances'), 'Balances']
	]},
	"Messages" : {icon: 'sprite-homepage-Sidebar-Messages2x', items: [
		[clientWebLink("/messages"), "Inbox"],
		[clientWebLink("/messages/archived"),"Archive"],
		[clientWebLink("/messages/compose"), "Compose"]
	]},
	"History" : {icon: 'sprite-homepage-Sidebar-History2x', items: [
		[clientWebLink("/history/details"), "Monthly Transactions"],
		[clientWebLink("/history/details?view=statement"),"Statements"]
	]},
	"Preferences": {icon: 'sprite-homepage-Sidebar-Prefences2x', items: [
		[clientWebLink('/preferences/personal'), 'Personal Details'],
		[clientWebLink('/preferences/password'), 'Change Password'],
		[clientWebLink('/preferences/security'), 'Security'],
		['/preferences/communication', 'Change Communication'],
		[clientWebLink('/withdrawal/preferences'), 'Access / Transfer Money']
	]},
	"Community": {icon: 'sprite-homepage-Sidebar-Community2x', items: [
		[clientWebLink('/mbforum'), 'Forum'],
		['http://www.mybudget.com.au/blog', 'Blog'],
		['http://www.mybudget.com.au/awards-media/', 'In the press'],
	]},
	"FAQ": {icon: 'sprite-homepage-Sidebar-FAQ2x', link: '/faq'},
	"About Us": {icon: 'sprite-homepage-Sidebar-AboutUs2x', items: [
		[clientWebLink('/about-us'), 'About Us'],
		[clientWebLink('/policies'), 'Out Policies'],
	]},
	"Contact": {icon: 'sprite-homepage-Sidebar-Contact2x', link: '/contact-us'},
}


export class Sidebar extends PureComponent{
	static propTypes = {
		location: PropTypes.object.isRequired
	}

	constructor(props){
		super(props)

		// Find the current route based on the react router
		const currentSection = Object.entries(items).find(([, options]) => {
			if(options.link){
				return options.link === props.location.pathname ? true : false
			}else{
				return options.items.find((links) => links[0] == props.location.pathname ? true : false)
			}
		})

		this.state = {
			section: currentSection ? currentSection[0] : false
		}
	}

	toggleSection(title, e){
		e.preventDefault()
		this.setState({
			section: this.state.section === title ? false : title
		})
	}

	render(){
		const {section} = this.state

		return (
			<nav className="col-xs-8 col-sm-3 col-md-3 col-lg-2 sidebar-offcanvas" id={styles.sidebar} role="navigation">
				<ul className={`nav ${styles.nav}`}>
					{Object.entries(items).map(([title, options]) => {
						const toggleSection = options.link ? () => {} : this.toggleSection.bind(this, title)
						return (
							<li className={className('sidebar-item', {active: section === title})} key={title}>
								<a
									href={options.link || '#'}
									onClick={toggleSection}
								>
									<span className={`${styles.icon} ${options.icon}`}></span>
									{title}
								</a>
								<If condition={options.items}>
									<ul className={className('collapse', {in: section === title})}>
										{options.items.map(([url, name]) => {
											return (
												<li key={url}>
													<Choose>
														<When condition={url[0] === '/'}>
															<Link to={url}>{name}</Link>
														</When>
														<Otherwise>
															<a href={url}>{name}</a>
														</Otherwise>
													</Choose>
												</li>
											)
										})}
									</ul>
								</If>
							</li>
						)
					})}
				</ul>
				<div className={styles.socialMediaIcons}>
					<div className={styles.title}>Follow Us</div>
					<div className={styles.icons}>
						<a href="http://www.facebook.com/mybudget" rel="publisher" title="Facebook" className="sprite-homepage-Social-Facebook-Icon2x text-hide" target="_blank">Facebook</a>
						<a href="http://www.twitter.com/mybudgetcomau" rel="publisher" title="Twitter" className="sprite-homepage-Social-Twitter-Icon2x text-hide" target="_blank">Twitter</a>
						<a href="http://www.linkedin.com/company/mybudget" rel="publisher" title="Linked In" className="sprite-homepage-Social-LinkedIn-Icon2x text-hide">Linked In</a>
						<a href="https://plus.google.com/+mybudget" rel="publisher" title="Google Plus" className="sprite-homepage-Social-GPlus-Icon2x text-hide">Google Plus</a>
						<a href="http://www.youtube.com/user/MyBudgetU2" rel="publisher" title="Youtube" className="sprite-homepage-Social-YouTube-Icon2x text-hide" target="_blank">Youtube</a>
					</div>
				</div>
			</nav>
		)
	}
}

export default withRouter(Sidebar)



// WEBPACK FOOTER //
// ./client/components/layout/Sidebar/index.js